export default __webpack_public_path__ + "f3cfa77f872db84ea9af8557a0dba17e.png";